import { uc } from '@/api/login'
import { initialRoutes } from '@/router/routes'
import { isNilOrEmpty, isNotNilOrEmpty } from 'ramda-adjunct'
import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(),
  routes: initialRoutes,
},
)
router.beforeEach(async (to) => {
  const { profile, updateProfile } = useProfileStore()
  // 跳到登陆页时判断是否已经登陆过
  if (to.name === 'Login') {
    if (!isNilOrEmpty(profile)) {
      return {
        name: 'Root',
        replace: true,
      }
    }
    return
  }
  if (isNilOrEmpty(profile)) {
    try {
      const res = await uc()
      updateProfile(res)
      if (to.name === 'Login') {
        return {
          name: 'Root',
          replace: true,
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 权限检查
  const targetPermissions = to.meta?.permissions ?? []
  const shouldCheckPermission = isNotNilOrEmpty(targetPermissions)
  if (shouldCheckPermission) {
    const staffHasPermission = usePermission().checkPermission(targetPermissions)
    if (!staffHasPermission) {
      return {
        name: '403',
      }
    }
  }
})

export default router
